import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Radio, Select } from 'antd';
import intl from 'react-intl-universal';
import { setListFilterParams } from '@/redux/actions/bill';

import { BILL_FILTER_TYPES, BILL_FILTER_STATES } from './config';
import styles from './index.module.scss';

const { Option } = Select;

function ListFilter(props) {
  const { subjects, filterParams } = props;

  const [filterSubjects, setFilterSubjects] = useState([]);

  const changeParams = (val, key) => {
    const newParams = { ...filterParams };
    newParams[key] = val;
    // 入账类型改变
    if (key === 'type') {
      if (val === -1) {
        // 全部
        setFilterSubjects(subjects);
      } else {
        // 过滤出对应付款、消费账务项目
        const list = subjects?.filter((item) => item.value === 'all' || item.type === val);
        setFilterSubjects(list);
        // 判断账务项目是否属于对应入账类型
        const currentSubject = list?.find((item) => item.value === newParams?.subjectCode);
        if (currentSubject?.type !== val) {
          newParams.subjectCode = 'all';
        }
      }
    }
    props.setListFilterParams(newParams);
  };

  useEffect(() => {
    setFilterSubjects(subjects);
  }, [subjects]);

  return (
    <div className={styles['bill-filter']}>
      <div className={styles['bill-filter-item']}>
        <label className="text-colon">{intl.get('bill_entry_bill_type')}</label>
        <Radio.Group
          value={filterParams.type}
          onChange={(e) => changeParams(e.target.value, 'type')}
        >
          {BILL_FILTER_TYPES.map((bt) => {
            return (
              <Radio.Button key={bt.value} value={bt.value}>
                {bt.label}
              </Radio.Button>
            );
          })}
        </Radio.Group>
      </div>
      <div className={styles['bill-filter-item']}>
        <label className="text-colon">{intl.get('bill_refound_res_bill_subject')}</label>
        <Select
          className={styles['filter-control']}
          placeholder={intl.get('bill_invoice_modal_please_select')}
          value={filterParams.subjectCode}
          onChange={(v) => changeParams(v, 'subjectCode')}
          id="select-area"
          style={{ width: 300 }}
        >
          {filterSubjects?.map((subj) => {
            return (
              <Option key={subj.value} value={subj.value}>
                {subj.label}
              </Option>
            );
          })}
        </Select>
      </div>
      <div className={styles['bill-filter-item']}>
        <label className="text-colon">{intl.get('bill_check_status')}</label>
        <Radio.Group
          value={filterParams.status}
          onChange={(e) => changeParams(e.target.value, 'status')}
        >
          {BILL_FILTER_STATES.map((bt) => {
            return (
              <Radio.Button key={bt.value} value={bt.value}>
                {bt.label}
              </Radio.Button>
            );
          })}
        </Radio.Group>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  const { subjects, filterParams } = state.bill;
  return { subjects, filterParams };
};

export default connect(mapStateToProps, { setListFilterParams })(ListFilter);
